import { PaymentProduct as PaymentProductStatus } from "ui/molecules/Status";
import withGridCellParams from "./withGridCellParams";

const PaymentProduct = withGridCellParams(({ value }) => (
    <PaymentProductStatus
        label={value}
    />
));

export default PaymentProduct;
